import {
    Backdrop as MuiBackdrop,
    BottomSheetContent as L2RBottomSheetContent,
    IconButton as UiIconButton,
    styledForMobile,
    styled,
} from "@l2r-front/l2r-ui"

import { DocumentFilterList as L2RDocumentFilterList } from "../DocumentFilterList"
import { DocumentFiltersForm as L2RDocumentFiltersForm } from "../DocumentFiltersForm"

export const IconButton = styled(UiIconButton)(({ theme }) => ({
    marginLeft: "auto",
    height: "fit-content",
    zIndex: theme.zIndex.appBar + 2,
}))

export const DisplayedFiltersWrapper = styledForMobile("div")(() => ({
    display: "flex",
}))

export const Wrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    position: "relative",
})

export const DocumentFiltersForm = styled(L2RDocumentFiltersForm)(({ theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    left: 0,
    position: "absolute",
    right: 0,
    width: "100%",
    zIndex: theme.zIndex.appBar + 1,
}))

export const SideComponentContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
}))

export const DocumentFilterList = styled(L2RDocumentFilterList)(({ theme }) => ({
    padding: theme.spacing(0, 3, 0, 0),
}))

export const BottomSheetContent = styled(L2RBottomSheetContent)(({ theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    position: "relative",
}))

export const BackdropFilter = styledForMobile(MuiBackdrop)(({ theme }) => ({
    backgroundColor: "transparent",
    cursor: "pointer",
    zIndex: theme.zIndex.mobileStepper,
}))